import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=e34fbeba&scoped=true&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=e34fbeba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34fbeba",
  null
  
)

export default component.exports